<template>
    <div>
        <div>
            <div class="container-fluid" v-if="count_selectors > 1">
                <div class="row">
                    <div class="col-12">
                        <ul role="tablist" class="inner-tabs nav nav-tabs flex-column flex-sm-row">
                            <li class="nav-item" v-for="selector in selectors">
                                <a href="#" role="tab" data-toggle="tab"
                                   @click="changeSelector(selector)"
                                   :class="[ 'nav-link', current_selector == selector ? 'active' : '' ]"
                                >{{ picker_trans[locale][selector] }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <component :is="current_selector"
                       :init_selected_users="selected_users"
                       :init_ignored_users="ignored_users"
                       :is_debug="is_debug"
                       v-model="selected_users"
                       :fetch_with_freshman_class="fetch_with_freshman_class"
                       :limit_user_type="limit_user_type"
                       :init_request_type="request_type"
                       :is_multiple="is_multiple"
                       :select_parent_by_student="select_parent_by_student"
                       :limit_years="limit_years"
                       :active_only="active_only"
                       :fetch_with_tuition_record="fetch_with_tuition_record"
                       :with_future_year="with_future_year"
                       v-if="is_general_selectors"
            >
            </component>
            <slot :current_selector="current_selector"
                  v-model="selected_users"
                  v-if="!is_general_selectors">
            </slot>
        </div>

        <div class="container-fluid" v-if="is_multiple">
            <div class="row">
                <div :class="[ 'pb-4', 'col-lg-' + (show_not_allow_remove_users ? '6' : '12') ]">
                    <div class="section-title">
                        {{ selected_user_title == '' ? trans[locale].selected_user : selected_user_title }}
                    </div>
                    <selected-user-table :init_selected_users="selected_users"
                                         v-model="selected_users"
                                         :with_parent_option="with_parent_option_for_selected_user_table"
                                         :select_parent_by_student="select_parent_by_student_for_selected_user_table"
                                         :is_debug="is_debug">
                    </selected-user-table>
                </div>
                <div class="col-lg-6" v-if="show_not_allow_remove_users">
                    <div class="section-title">
                        {{ not_allow_users_title == '' ? trans[locale].not_allow_remove_users : not_allow_users_title }}
                    </div>
                    <not-allow-remove-user-table
                            :init_not_allow_remove_users="not_allow_remove_users"
                            :is_debug="is_debug"
                    >
                    </not-allow-remove-user-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { helperCommon } from "../../mixins/helper.common";
    import SelectedUserTable from "./SelectedUserTable";
    import NotAllowRemoveUserTable from "./NotAllowRemoveUserTable";
    import SelectorClassStudent from "./SelectorClassStudent";
    import SelectorStudent from "./SelectorStudent";
    import SelectorTeacher from "./SelectorTeacher";
    import SelectorParent from "./SelectorParent";

    export default {
        mixins: [ helperCommon ],
        props: {
            /*
             if using custom template for general selector, should be set custom_selector to true
            */
            custom_selector: {
                required:false,
                type: Boolean,
                default: false
            },
            init_selectors: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                }
            },
            init_current_selector: {
                required: true,
                type: String,
                default: 'SelectorStudent'
            },
            selected_user_title: {
                required: false,
                type: String,
                default: '',
            },
            init_selected_users: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                }
            },
            init_ignored_users: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                }
            },
            init_request_type: {
                required: false,
                type: String,
                default: 'account',
            },
            is_multiple: {
                required: false,
                type: Boolean,
                default: true,
            },
            not_allow_users_title: {
                required: false,
                type: String,
                default: '',
            },
            show_not_allow_remove_users: {
                required: false,
                type: Boolean,
                default: false,
            },
            init_not_allow_remove_users: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                }
            },
            is_debug: {
                required: false,
                type: Boolean,
                default: false
            },
            parent_event_for_retrieving_selected_users: {
                required: false,
                type: String,
                default: null,
            },
            with_parent_option: {
                required: false,
                type: Boolean,
                default: false,
            },
            select_parent_by_student: {
                required: false,
                type: Boolean,
                default: false,
            },
            limit_user_type: {
                type: Array,
                required: false,
                default: () => {
                    return [
                        'teacher',
                        'parent',
                        'student',
                    ];
                }
            },
            fetch_with_freshman_class: {
                type: Boolean,
                required: false,
                default: false,
            },
            limit_years : {
                type: Array,
                required: false
            },
            active_only : {
                type: Boolean,
                required: false,
                default: () => false,
            },
            fetch_with_tuition_record: {
                type: Boolean,
                required: false,
            },
            with_future_year: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return Object.assign(
                {
                    trans: {
                        'zh-HK': {
                            'name': '名稱',
                            'selected_user': '已選用戶',
                            'not_allow_remove_users': '用戶(已鎖定)',
                        },
                        'en': {
                            'name': 'Name',
                            'selected_user': 'Selected Users',
                            'not_allow_remove_users': 'Users (Locked)',
                        },
                    },
                    picker_trans: {
                        'zh-HK': {
                            'SelectorStudent': '學生篩選',
                            'SelectorClassStudent': '班別篩選',
                            'SelectorTeacher': '教職員篩選',
                            'SelectorStaffAttendance': '職員篩選',
                            'SelectorParent': '家長/監護人篩選',
                            'SelectorGroupUser': '小組成員篩選',
                            'SelectorManager': '校董篩選',
                        },
                        'en': {
                            'SelectorStudent': 'Student Selector',
                            'SelectorClassStudent': 'Class Selector',
                            'SelectorTeacher': 'Teaching Staff Selector',
                            'SelectorStaffAttendance': 'Staff Selector',
                            'SelectorParent': 'Parent Selector',
                            'SelectorGroupUser': 'Group User Selector',
                            'SelectorManager': 'Manager Selector',
                        }
                    },
                    is_general_selectors: false,
                    general_selectors: [
                        'SelectorClassStudent',
                        'SelectorStudent',
                        'SelectorTeacher',
                        'SelectorParent',
                        'SelectorGroupUser',
                        'SelectorManager',
                    ],
                    selectors: this.init_selectors,
                    selected_users: this.init_selected_users,
                    ignored_users: this.init_ignored_users,
                    not_allow_remove_users: this.init_not_allow_remove_users,
                    current_selector: this.init_current_selector,
                    request_type: this.init_request_type,
                    component_name: this.$options.name,
                    count_selectors: 0,
                },
                { locale: window.locale }
            );
        },
        components: {
            SelectorStudent,
            SelectorClassStudent,
            SelectorTeacher,
            SelectorParent,
            SelectedUserTable,
            NotAllowRemoveUserTable,
        },
        beforeMount() {
            if (this.is_debug) this.debugMessage('*** BEFORE MOUNT => [' + this.component_name + ']', 'warning');
            this.debug_info('warning');
            if (_.size(this.selectors) == 0)
            {
                this.selectors.push(this.current_selector);
            }
            this.count_selectors = _.size(this.selectors);
            // window.eventHub.$off('update-picker-selected-users');
            window.eventHub.$off('update-picker-ignored-users');
            window.eventHub.$off('update-picker-not-allow-remove-users');
        },
        beforeDestroy() {
            if (this.is_debug) this.debugMessage('*** BEFORE DESTROY => [' + this.component_name + ']', 'warning');
            this.debug_info('warning');
            // window.eventHub.$off('update-picker-selected-users');
            window.eventHub.$off('update-picker-ignored-users');
            window.eventHub.$off('update-picker-not-allow-remove-users');
        },
        mounted() {
            let self = this;
            if (this.is_debug) this.debugMessage('*** MOUNTED => [' + this.component_name + ']');
            this.debug_info();

            this.is_general_selectors = _.includes(this.general_selectors, this.current_selector);

            // instead of v-model input event
            //
            // window.eventHub.$on('update-picker-selected-users', (selected_users) => {
            //     this.selected_users = selected_users;
            //
            //     if (self.is_debug) self.debugMessage('*** EVENT EMIT => [' + self.component_name + '] => { update-picker-selected-users }', 'success');
            //     self.debug_info('success');
            //
            //     window.eventHub.$emit(_.toLower(this.current_selector) + '-update-selected-users', this.selected_users);
            //
            //     // define Parent event for retrieving selected users
            //     if (!_.isUndefined(self.parent_event_for_retrieving_selected_users) &&
            //         !_.isNull(self.parent_event_for_retrieving_selected_users))
            //     {
            //         window.eventHub.$emit(self.parent_event_for_retrieving_selected_users, this.selected_users);
            //     }
            // });

            window.eventHub.$on('update-picker-ignored-users', (ignored_users) => {
                this.ignored_users = ignored_users;
            });

            window.eventHub.$on('update-picker-not-allow-remove-users', (not_allow_remove_users) => {
                let new_users = self._cloneObject(self.not_allow_remove_users);
                let ignored_users = self._cloneObject(self.ignored_users);
                _.forEach(not_allow_remove_users, (user) => {
                    new_users.push(user);
                    ignored_users.push(user);
                });
                new_users = _.uniqBy(new_users, function (e) {
                    return e.key;
                });
                ignored_users = _.uniqBy(ignored_users, function (e) {
                    return e.key;
                });
                self.not_allow_remove_users = self._cloneObject(new_users);
                self.ignored_users = self._cloneObject(ignored_users);
                window.eventHub.$emit('update-picker-table-not-allow-remove-users', self.not_allow_remove_users);
                window.eventHub.$emit(_.toLower(this.current_selector) + '-update-ignored-users', self.ignored_users);
            });

            window.eventHub.$emit(_.toLower(this.current_selector) + '-initial-selector', this.selected_users);
        },
        watch: {
            init_selected_users: {
                handler(new_value) {
                    this.selected_users = this.init_selected_users;
                },
                deep: true,
            },
            selected_users: {
                handler(newVal) {
                    /*
                    this event is using to bind value for v-model
                     */
                    this.$emit('input', this.selected_users);
                    // define Parent event for retrieving selected users
                    if (!_.isUndefined(this.parent_event_for_retrieving_selected_users) &&
                        !_.isNull(this.parent_event_for_retrieving_selected_users))
                    {
                        window.eventHub.$emit(this.parent_event_for_retrieving_selected_users, this.selected_users);
                    }
                    // window.eventHub.$emit(_.toLower(this.current_selector) + '-update-selected-users', this.selected_users)
                },
                deep: true
            }
        },
        computed: {
            with_parent_option_for_selected_user_table() {
                return this.with_parent_option && _.includes([
                        'SelectorClassStudent',
                        'SelectorStudent',
                        'SelectorGroupUser',
                    ], this.current_selector);
            },
            select_parent_by_student_for_selected_user_table() {
                return this.select_parent_by_student && _.includes([
                    'SelectorClassStudent',
                    'SelectorStudent',
                    'SelectorGroupUser',
                ], this.current_selector);
            }
        },
        methods: {
            debug_info(color_type) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] : Selected users: ' + JSON.stringify(this.selected_users), color_type);
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] :' + ' Ignored users: ' + JSON.stringify(this.ignored_users), color_type);
            },
            changeSelector(selector) {

                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [changeSelector]', 'gray');

                this.current_selector = selector;
                this.is_general_selectors = _.includes(this.general_selectors, this.current_selector);

                this.$nextTick(() => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] :' + _.toLower(this.current_selector) + '-initial-selector', 'gray');
                    window.eventHub.$emit(_.toLower(this.current_selector) + '-initial-selector', this.selected_users);
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UserPicker/UserPicker.vue